<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-card ref="scroll_target" flat class="scroll-y" :height="calcHeight()">
    <v-container px-2 pt-2
      fluid
      grid-list-lg
      style="min-height: 0; margin-top: 0"
      >
    <template v-if="!isEdit">
      <v-card-text>
      </v-card-text>
    </template>
    <template v-if="isEdit">
    <v-form v-model="valid" ref="form">
      <v-card-text>
      <v-layout column>
        <v-flex>
          <v-textarea
            ref="focused"
            label="Корпоративные заметки"
            rows="5"
            persistent-hint
            hint="Корпоративные заметки видны только пользователям Вашей компании"
            v-model="item.text"
          ></v-textarea>
        </v-flex>
        <v-flex>
          <v-layout row>
            <v-text-field
              prepend-icon="attach_file"
              @click:prepend="dialogOpen"
              label="Ссылка на документ"
              hint=""
              v-model="item.link"
            ></v-text-field>
            <v-btn :disabled='!this.item.link' @click="addLink">Добавить</v-btn>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row align-up justify-end>
          <v-flex>
          <v-chip
            v-for="tag in item.tags"
            :key = tag.id
            small
            disabled
            text-color="secondary"
          >
            <span class="text-xs-center">
            {{tag.name}}
            </span>
          </v-chip>
          </v-flex>
          <v-btn @click="addTag">Метки</v-btn>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout row align-center justify-end>
          <v-flex>
          <v-chip
            small
            disabled
            text-color="secondary"
          >
            <v-icon v-show="item.monitoring">alarm</v-icon>
            <v-icon v-show="!item.monitoring">alarm_off</v-icon>
          </v-chip>
          </v-flex>
          <v-btn @click="switchMonitoring">Мониторинг</v-btn>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-textarea
            label="Личные заметки"
            rows="2"
            persistent-hint
            hint="Личные заметки видны только Вам"
            v-model="item.privateNotes"
          ></v-textarea>
        </v-flex>

      <v-flex xs12 md12 pa-2>
        <v-card flat ref="scroll_target">
          <v-toolbar dense flat >
            <v-toolbar-title>Банки
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="openCompanyBank()">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container pt-2 px-2
            fluid
            grid-list-lg
            style="min-height: 0; margin-top: "
          >
            <v-layout row wrap >
              <template v-for="item in banks">
                <v-flex xs12 sm6>
                <v-card>
                  <v-card-title>
                    <span class="subheading"><component :is="createBankTitle(item)"></component></span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text>
                    <component :is="createBankContent(item)">
                    </component>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="openCompanyBank(item)">Изменить</v-btn>
                  </v-card-actions>
                </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card>
       </v-flex>

      <v-flex xs12 md12 pa-2>
        <v-card flat ref="scroll_target">
          <v-toolbar dense flat >
            <v-toolbar-title>Контакты
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="openContact()">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container pt-2 px-2
            fluid
            grid-list-lg
            style="min-height: 0; margin-top: "
          >
            <v-layout row wrap >
              <template v-for="item in contacts">
                <v-flex xs12 sm6>
                <v-card>
                  <v-card-title>
                    <span class="subheading"><component :is="createContactTitle(item)"></component></span>
                    <v-spacer></v-spacer>
                  </v-card-title>
                  <v-card-text>
                    <component :is="createContactContent(item)">
                    </component>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="openContact(item)">Изменить</v-btn>
                  </v-card-actions>
                </v-card>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card>
       </v-flex>

      </v-layout>
      </v-card-text>
      </v-form>
    </template>
    </v-container>
    </v-card>
    <template #actions>
      <v-btn :disabled='!valid' @click="add">Сохранить</v-btn>
      <v-btn @click="remove">Удалить</v-btn>
      <v-spacer></v-spacer>
    </template>  
  </v-btn-form>
</template>
<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats.js'
  import vTagSelector from '../favorite/TagSelector'
  import dialogs from '../common/dialogs'
  import depo from '../depo'
  import favorite from '../favorite'
  import people from '../people'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'notes-form',
    components: {vBtnForm},
    data: () => ({
      edit: true,
      valid: false,
      item: {}
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      model: {
        type: Object,
        default: null
      }
    },
    created () {
      if (!this.model) {
        this.item = this.getItemNew()
      } else {
        this.item.ref = this.model.company.reference.ref
        this.item.inn = this.model.company.inn
        this.item.nameShort = this.model.company.name.caption
        this.item.clientCompanyId = this.model.clientCompanyId
        this.item.text = this.model.notes
        this.item.link = null
        this.item.lastUid = null
        this.item.tags = this.model.tags.slice()
        this.item.monitoring = this.model.monitoring
        this.item.privateNotes = this.model.privateNotes
        this.fetchCompanyBanks(this.item.ref)
        this.fetchCompanyContacts(this.item.ref)
      }
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        profile: 'getProfile',
        getTags: 'getTags',
        getDepoUrl: 'getDepoUrl'
      }),
      docLink () {
        return this.item.link ? this.item.link : ''
      },
      isEdit () {
        return this.edit || this.isNew
      },
      isNew () {
        return false
      },
      title () {
        return this.isNew ? `Добавление ${this.item.nameShort}` : this.isEdit ? `Атрибуты ${this.item.nameShort}` : `Атрибуты ${this.item.nameShort}`
      },
      banks () {
        return this.item && this.item.banks ? this.item.banks.sort((a, b) => formats.compareString(a.name, b.name)) : []
      },
      contacts () {
        return this.item && this.item.contacts ? people.sortContactsByCompany(this.item.contacts) : []
      }
    },
    methods: {
      calcHeight () {
        var height = this.$vuetify.breakpoint.height - 48 - 48 - 16
        if (this.fullscreen) {
          height = height + 8
        } else {
          height = height - 148 + 16 + 64
        }
        return height + 'px'
      },
      fetchCompanyBanks (refCode) {
        this.$store.dispatch('getCompanyBanks', refCode).then((data) => {
          this.item.banks = data
          this.item = Object.assign({}, this.item)
        })
      },
      fetchCompanyContacts (refCode) {
        this.$store.dispatch('getCompanyContacts', refCode).then((data) => {
          this.item.contacts = data
          console.log('fetchCompanyContacts', data)
          this.item = Object.assign({}, this.item)
        })
      },
      add () {
        if (this.$refs.form.validate()) {
          this.$store.dispatch('updateFavoriteCompanyNotes', {refCode: this.item.ref, notes: this.item.text, privateNotes: this.item.privateNotes})
          this.$store.dispatch('updateFavoriteCompanyTags', {refCode: this.item.ref, tags: this.item.tags})
          this.$store.dispatch('updateMonitoringCompanies', {refCodes: [this.item.ref], monitoring: this.item.monitoring})
          this.edit = false
          this.$emit('input', this.item.text)
          this.cancel()
        }
      },
      remove () {
        dialogs.confirm(this,
          'Подтвердите',
          'Убрать из "Мои контрагенты" и отключить мониторинг компаний?',
          (self) => {
            self.$store.dispatch('deleteFavoriteCompanies', {refCodes: [this.item.ref]})
            self.$emit('input', '')
            self.cancel()
          })
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          ref: null,
          clientCompanyId: null,
          banks: [],
          inn: null,
          nameShort: null,
          text: '',
          link: null,
          lastUid: null,
          tags: [],
          monitoring: false,
          privateNotes: ''
        }
      },
      addLink () {
        let docLink = this.docLink
        Promise.resolve().then(() => {
          if (docLink.includes(this.item.lastUid)) {
            return new Promise((resolve, reject) => {
              this.$store.dispatch('getDepoFile', this.item.lastUid).then(files => {
                resolve(files && files[0] && files[0].docName || docLink)
              })
            })
          }
          return docLink
        }).then((refName) => {
          this.item.text = (this.item.text || '') + `<a href="${docLink}">${refName}</a>`
          this.item.link = null
          this.item.lastUid = null
        })
      },
      dialogOpen: function () {
        var self = this
        const setDoc = function (value) {
          var docLink = self.getDepoUrl(value)
          self.item.lastUid = value
          self.item.link = docLink
          self.item = Object.assign({}, self.item)
        }
        depo.selectDoc(this, setDoc)
      },
      addTag () {
        var self = this
        const setItems = function (tagIds) {
          self.item.tags = self.getTags.filter(t => tagIds.includes(t.id))
          self.item = Object.assign({}, self.item)
        }
        dialogs.register('v-tag-selector', vTagSelector)
        var comp = { template: `
          <v-tag-selector v-on:close="$emit('close')"
          v-on:input="setItems"
          :fullscreen="fullscreen" :selected="selected"></v-tag-selector>
          `,
          data () {
            return {
              fullscreen: self.fullscreen,
              setItems: setItems,
              selected: self.item.tags.map(t => t.id)
            }
          }
        }
        dialogs.modal(comp)
      },
      switchMonitoring () {
        this.item.monitoring = !this.item.monitoring
        this.item = Object.assign({}, this.item)
      },
      openCompanyBank (item) {
        let id = item ? item.id : null
        favorite.openCompanyBank(id, this.item.ref, this.item.nameShort, this.item.clientCompanyId).then(() => {
          this.fetchCompanyBanks(this.item.ref)
        })
      },
      createBankTitle (item) {
        let strategy = favorite.createStrategy(this, 'COMPANY_BANK')
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromData(item))
        }
        return formats.createComp('<span>Новый тип документа</span>')
      },
      createBankContent (item) {
        let strategy = favorite.createStrategy(this, 'COMPANY_BANK')
        if (strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromData(item))
        }
        return formats.createComp('<span></span>')
      },
      openContact (item) {
        let id = item ? item.id : null
        favorite.openCompanyContact(id, this.item.ref, this.item.nameShort, this.item.clientCompanyId).then(() => {
          this.fetchCompanyContacts(this.item.ref)
        })
      },
      createContactTitle (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        strategy.setParentProps({refCode: this.item.ref})
        if (strategy && strategy.viewTitleComp) {
          return strategy.viewTitleComp(strategy.createModelFromData(item))
        }
        return this.createComp('<span>Новый тип документа</span>')
      },
      createContactContent (item) {
        let strategy = people.createStrategy(this, 'CONTACT')
        strategy.setParentProps({refCode: this.item.ref})
        if (strategy && strategy.viewContentComp) {
          return strategy.viewContentComp(strategy.createModelFromData(item))
        }
        return this.createComp('<span></span>')
      }
    }
  }

</script>




// WEBPACK FOOTER //
// NotesForm.vue?8dffb436